import { connect } from 'react-redux';
import { getPhotoCaptureAttachmentInfo, DownloadArtifactsComponent, getDownloadArtifactAuthDetails, getPhotoCaptureCountryCode, getPhotoCaptureContextId, getPhotoCaptureCompanyCode, getPhotoCaptureIntelligentReactivationUrlDataAction, photoCaptureFileDownloadStartAction, photoCaptureFileDownloadCompleteAction } from "../../../domain/photoCapture";
const mapStateToProps = (state) => ({
    photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
    downloadArtifactAuthDetailsInfo: getDownloadArtifactAuthDetails(state),
    countryCode: getPhotoCaptureCountryCode(state),
    contextId: getPhotoCaptureContextId(state),
    companyCode: getPhotoCaptureCompanyCode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onHandleReactivationCall: (companyCode, contextId) => {
        dispatch(getPhotoCaptureIntelligentReactivationUrlDataAction(companyCode, contextId));
    },
    onDownloadStart: () => {
        dispatch(photoCaptureFileDownloadStartAction());
    },
    onDownloadComplete: () => {
        dispatch(photoCaptureFileDownloadCompleteAction());
    }
});
export const ConnectedDownloadArtifactsComponent = connect(mapStateToProps, mapDispatchToProps)(DownloadArtifactsComponent);
//# sourceMappingURL=ConnectedDownloadArtifactsComponent.js.map